import { baseUCGet } from '../base/baseUC';

const str = '';

export const countryModelGet = ({userId = ''}) => {
    return {
        alphaCode2: str,
        alphaCode3: str,
        description: str,
        numeric: str,
        ...baseUCGet({userId: userId, }),
    }
};